import api from "./client";

export async function getPendingQualityApprovals() {
  const res = await api.get("/quality/pending");
  return res.data.data; // array
}

export async function getQualityApprovals(status = "all") {
  const res = await api.get("/quality/approvals", { params: { status } });
  return res.data.data; // array
}

export async function approveQualityApproval(approvalId, payload = {}) {
  const res = await api.post(`/quality/approvals/${approvalId}/approve`, payload);
  return res.data.data;
}

export async function rejectQualityApproval(approvalId, payload = {}) {
  const res = await api.post(`/quality/approvals/${approvalId}/reject`, payload);
  return res.data.data;
}

